import { qaBackendApiInstance } from "@src/config/config"

export async function saveFavoriteVoices(voice_name:string, voice_id:string){
    const token = localStorage.getItem('accessToken')
    
    const postBody={
      voice_name:voice_name,
      voice_id:voice_id
    }
    try{
      const response = await qaBackendApiInstance.post('/voice/save-favorite-voice',
        postBody,
        {
          headers: {
              'Authorization': `Bearer ${token}`
          }
      }
  
      )
      return response.data
    }catch(error){
      return -1
    }
  }
  
  export async function getFavouredVoices(){
    const token = localStorage.getItem('accessToken')
    try{
      
      const response = await qaBackendApiInstance.get(`/voice/get-favorite-voice`, 
        {
        headers: {
          'Authorization': `Bearer ${token}`
          
        }
      });
    
      return response.data.favorite_voices;
    }catch(error){
    return -1
    }
  }
  
  export async function deleteFavouredVoice(id:string){
    const token = localStorage.getItem('accessToken')
  
    try{
      const response = await qaBackendApiInstance.delete(`/voice/delete-favorite-voice/${id}`,
        {
          headers: {
              'Authorization': `Bearer ${token}`
          }
      }
      )
      
        return response.data
    }catch(error){
      return -1
    }
  }